import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Filter, X } from 'lucide-react';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { useContractorFilter, AVAILABLE_CONTRACTORS } from '../contexts/ContractorFilterContext';
export function FilterBanner() {
  const {
    selectedProjects,
    setSelectedProjects
  } = useProjectFilter();
  const {
    selectedContractors,
    setSelectedContractors
  } = useContractorFilter();
  const allProjectsSelected = selectedProjects.length === AVAILABLE_PROJECTS.length;
  const allContractorsSelected = selectedContractors.length === AVAILABLE_CONTRACTORS.length;
  const hasActiveFilters = !allProjectsSelected || !allContractorsSelected;
  const handleClearFilters = () => {
    setSelectedProjects(AVAILABLE_PROJECTS);
    setSelectedContractors(AVAILABLE_CONTRACTORS);
  };
  const getFilterText = () => {
    const parts = [];
    if (!allProjectsSelected) {
      parts.push(`${selectedProjects.length} of ${AVAILABLE_PROJECTS.length} sites`);
    }
    if (!allContractorsSelected) {
      parts.push(`${selectedContractors.length} of ${AVAILABLE_CONTRACTORS.length} contractors`);
    }
    return `Showing data for ${parts.join(' and ')}`;
  };
  return <AnimatePresence data-id="element-593">
      {hasActiveFilters && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="overflow-hidden" data-id="element-594">
          <div className="bg-amber-100 border border-amber-300 rounded-lg px-4 py-2.5 mb-2" data-id="element-595">
            <div className="flex items-center justify-between" data-id="element-596">
              <div className="flex items-center gap-2 text-sm text-amber-900" data-id="element-597">
                <Filter size={16} className="text-amber-600" data-id="element-598" />
                <span className="font-semibold" data-id="element-599">{getFilterText()}</span>
              </div>
              <button onClick={handleClearFilters} className="flex items-center gap-1.5 text-xs font-semibold text-amber-800 hover:text-amber-950 bg-amber-200 hover:bg-amber-300 px-2.5 py-1.5 rounded-md transition-colors" data-id="element-600">
                <X size={14} data-id="element-601" />
                Clear filters
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}